import { put, takeLatest } from 'redux-saga/effects';

import { networkErrorHandler } from 'utils/errrorHandlers';
import request from 'utils/request';
import urls from 'utils/config';
import { successNotifier } from 'utils/helpers';
import { addInstitutionSuccess } from 'redux/configurations/actions';
import paymentConfigTypes from '../types';

const { API_BASE_URL } = urls || {};

function* updatePlatformChargeStatus({
  payload: { institutionInfo, newPlatformChargeStatus, cb },
}) {
  const url = `${API_BASE_URL}/organisation`;
  const data = new FormData();
  data.append('platformChargeEnabled', newPlatformChargeStatus);
  data.append('name', institutionInfo.name);
  data.append('timeZone', institutionInfo.timeZone);

  const response = yield request({
    method: 'put',
    data,
    url,
  });

  if (response.success) {
    yield put(addInstitutionSuccess(response.raw));
    successNotifier(
      `You have successfully ${
        newPlatformChargeStatus ? 'activated' : 'deactivated'
      } platform charges for this account`
    );

    cb();
  } else {
    networkErrorHandler(
      response.statusCode,
      `An error occured deactivating platform charge for ${response.raw?.paymentPlatform?.toLowerCase()}`
    );
  }
}

export function* onUpdatePlatformChargeStatus() {
  yield takeLatest(
    paymentConfigTypes.UPDATE_PLATFORM_CHARGE_REQUEST,
    updatePlatformChargeStatus
  );
}
